import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import PropTypes from 'prop-types';
import { a as addClassNames, c as classNamePropTypes } from './classNames-1ed461aa.js';
import { a as addSpacingClasses, m as marginPropTypes } from './spacing-0f39ba4a.js';

var IllustrationNames = ['404', 'analysis', 'app-manager', 'authoring', 'bce', 'blank', 'bug', 'carousel-editor', 'chartlos', 'collect', 'conference', 'content-creator', 'control-panel', 'curation', 'developer', 'empty', 'error', 'finish-line', 'gams', 'high-five', 'image-manager', 'in-todays-paper', 'live-coverage', 'methode', 'news-alerts', 'newsgrid', 'newsroom-links', 'no-access', 'no-data', 'no-notifications', 'no-schedule', 'notes', 'pubcrawl', 'secure-data', 'server-down', 'status-update', 'typewriter', 'upload', 'walking', 'warning', 'webpage', 'weekly-advisor'];

function Illustration({
  name,
  margin,
  className,
  ...otherProps
}) {
  let cssClasses = ['st_illustration'];
  cssClasses = addClassNames(className, cssClasses);
  cssClasses = addSpacingClasses({
    margin,
    cssClasses
  });
  return /*#__PURE__*/React.createElement("img", _extends({}, otherProps, {
    alt: name,
    className: cssClasses.join(' '),
    src: `https://screentone.dowjones.io/assets/${name}.svg?src=st_illustration`,
    crossOrigin: "anonymous"
  }));
}
Illustration.propTypes = {
  /** Name of the illustration to be displayed */
  name: PropTypes.oneOf(IllustrationNames).isRequired,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /** margin for component, if any */
  margin: marginPropTypes
};
Illustration.defaultProps = {
  className: null,
  margin: null
};

export { Illustration as I };
